// extracted by mini-css-extract-plugin
module.exports = {"timetablePanel":"AFMr2r4","btnRow":"p9A8ybk","iconSpin":"G3R3ZQV"};